export default [
  // 人脸认证兑换码V1.0
  {
    path: '/fsl/:code',
    name: 'fslIndex',
    meta: { title: '提卡码' },
    component: () => import('@/views/fsl')
  },
  {
    path: '/fslList',
    name: 'fslList',
    meta: { title: '提卡码' },
    component: () => import('@/views/fsl/list')
  },
  {
    path: '/fslCrowded',
    name: 'fslCrowded',
    meta: { title: '提卡码' },
    component: () => import('@/views/fsl/crowded')
  },
  {
    path: '/fslOutStock',
    name: 'fslOutStock',
    meta: { title: '提卡码' },
    component: () => import('@/views/fsl/outStock')
  }
]
